import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Scale, Building, Mail, Globe } from 'lucide-react';

export default function AvisoLegalPage() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="aviso-legal-page">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <ArrowLeft size={18} className="text-slate-500" />
            <span className="text-sm text-slate-600">Volver a inicio</span>
          </Link>
          <Link to="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_baja-laboral-riesgos/artifacts/m7tg5pgh_logo.jpg" 
              alt="PrevenciónLegal @tecnoabogado" 
              className="h-10 w-auto"
            />
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center gap-3 mb-8">
          <Scale className="text-rose-600" size={32} />
          <h1 className="text-3xl font-bold text-slate-900">Aviso Legal</h1>
        </div>
        <p className="text-sm text-slate-500 mb-8">Última actualización: Abril 2026</p>

        <div className="prose prose-slate max-w-none space-y-8">
          <section className="bg-white border border-slate-200 p-6">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <Building size={20} />
              1. Identificación del Titular
            </h2>
            <p className="text-slate-600 mb-4">En cumplimiento de la Ley 34/2002 de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa:</p>
            <ul className="space-y-2 text-slate-600">
              <li><strong>Titular:</strong> José Luis Vilaplana</li>
              <li><strong>Nombre comercial:</strong> vilaplana@tecnoabogado</li>
              <li><strong>Email:</strong> <a href="mailto:info@tecnoabogado.com" className="text-rose-600 hover:underline">info@tecnoabogado.com</a></li>
              <li><strong>Webs asociadas:</strong> 
                <a href="https://www.tecnoabogado.com" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline ml-2">tecnoabogado.com</a>, 
                <a href="https://www.vilaplanaabogados.com" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline ml-2">vilaplanaabogados.com</a>, 
                <a href="https://www.despido.net" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline ml-2">despido.net</a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Objeto del Sitio Web</h2>
            <p className="text-slate-600">Este sitio web tiene como finalidad proporcionar información, herramientas de análisis y recursos sobre prevención de riesgos laborales, especialmente en el ámbito de las reincorporaciones tras bajas prolongadas, en el marco de la normativa española y europea vigente (Ley 2/2025, LISOS, LPRL).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Condiciones de Uso</h2>
            <p className="text-slate-600 mb-4">El acceso y uso de este sitio web implica la aceptación de las siguientes condiciones:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li>El contenido tiene carácter meramente informativo y no constituye asesoramiento legal profesional.</li>
              <li>Las herramientas de cálculo y análisis proporcionan estimaciones orientativas basadas en los parámetros introducidos.</li>
              <li>Para decisiones empresariales o legales, se recomienda consultar con un profesional especializado.</li>
              <li>El usuario se compromete a hacer un uso lícito del sitio web.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Propiedad Intelectual</h2>
            <p className="text-slate-600 mb-4">Todos los contenidos del sitio web, incluyendo textos, gráficos, imágenes, diseño, código fuente, marcas y logotipos, son propiedad del titular o de terceros que han autorizado su uso.</p>
            <p className="text-slate-600">Queda prohibida la reproducción, distribución, comunicación pública o transformación de los contenidos sin autorización expresa, salvo para uso personal y privado.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">5. Exclusión de Responsabilidad</h2>
            <p className="text-slate-600 mb-4">El titular no se hace responsable de:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li>Errores u omisiones en los contenidos informativos.</li>
              <li>Decisiones tomadas en base a la información o cálculos proporcionados.</li>
              <li>Daños derivados del uso del sitio web o de la imposibilidad de acceder al mismo.</li>
              <li>Contenidos de sitios web enlazados.</li>
              <li>Virus o elementos lesivos introducidos por terceros.</li>
            </ul>
            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mt-4">
              <p className="text-amber-800"><strong>Aviso importante:</strong> Los resultados del analizador de riesgos LISOS son orientativos y no sustituyen el asesoramiento legal profesional. La aplicación de medidas legales requiere la supervisión de un abogado especializado.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Enlaces Externos</h2>
            <p className="text-slate-600">Este sitio web puede contener enlaces a sitios de terceros. El titular no asume responsabilidad alguna por el contenido, políticas de privacidad o prácticas de dichos sitios externos.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Protección de Datos</h2>
            <p className="text-slate-600">El tratamiento de datos personales se rige por nuestra <Link to="/legal/privacidad" className="text-rose-600 hover:underline">Política de Privacidad</Link>, conforme al Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales (LOPDGDD).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">8. Legislación Aplicable y Jurisdicción</h2>
            <p className="text-slate-600">Las presentes condiciones se rigen por la legislación española. Para cualquier controversia derivada del acceso o uso del sitio web, las partes se someten a los Juzgados y Tribunales de la ciudad de domicilio del titular, salvo que la normativa aplicable determine otro fuero.</p>
          </section>

          <section className="bg-slate-100 p-6 border border-slate-200">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <Mail size={20} />
              Contacto
            </h2>
            <p className="text-slate-600 mb-4">Para cualquier consulta relacionada con este aviso legal:</p>
            <ul className="space-y-2 text-slate-600">
              <li><strong>Email:</strong> <a href="mailto:info@tecnoabogado.com" className="text-rose-600 hover:underline">info@tecnoabogado.com</a></li>
              <li className="flex items-center gap-2">
                <Globe size={16} />
                <a href="https://www.tecnoabogado.com" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">www.tecnoabogado.com</a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Documentos relacionados</h2>
            <ul className="space-y-2">
              <li><Link to="/legal/privacidad" className="text-rose-600 hover:underline">→ Política de Privacidad</Link></li>
              <li><Link to="/legal/cookies" className="text-rose-600 hover:underline">→ Política de Cookies</Link></li>
            </ul>
          </section>
        </div>
      </main>

      {/* Footer simple */}
      <footer className="bg-slate-900 text-slate-400 py-8 px-6">
        <div className="max-w-4xl mx-auto text-center text-sm">
          <p>© 2026 vilaplana@tecnoabogado. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
